import './OxylinkNavBar.scss';

import React from 'react';

import { useIdelinkTheme } from '../../../../xlink/configs/IdeLinkTheme';
import {
	NavbarBase,
	NavBarFactory,
	NavBarProps,
} from '../../../../libs/IdeLink.Web.Common/src/components/NavBar';
import { NavBarCategoryItem } from '../../../../libs/IdeLink.Web.Common/src/components/NavBar/components';
import { AreasModule } from '../../../../xlink/modules/Areas/AreasModule';
import { AuditsModule } from '../../../../xlink/modules/Audits/AuditsModule';
import { BackUsersModule } from '../../../../xlink/modules/BackUsers/BackUsersModule';
import { ChallengesModule } from '../../../../xlink/modules/Challenges/ChallengesModule';
import { CollectionsModule } from '../../../../xlink/modules/Collections/CollectionsModule';
import { ContactsModule } from '../../../../xlink/modules/Contacts/ContactsModule';
import { EventsModule } from '../../../../xlink/modules/Events/EventsModule';
import { FrontUsersModule } from '../../../../xlink/modules/FrontUsers/FrontUsersModule';
import { NewsModule } from '../../../../xlink/modules/News/NewsModule';
import { OffersModule } from '../../../../xlink/modules/Offers/OffersModule';
import { QuizzesModule } from '../../../../xlink/modules/Quizzes/QuizzesModule';
import { RolesModule } from '../../../../xlink/modules/Roles/RolesModule';
import { SectorsModule } from '../../../../xlink/modules/Sectors/SectorsModule';
import { ShopsModule } from '../../../../xlink/modules/Shops/ShopsModule';
import { StatsModule } from '../../../../xlink/modules/Stats/StatsModule';
import { SurveysModule } from '../../../../xlink/modules/Surveys/SurveysModule';
import { TagsModule } from '../../../../xlink/modules/Tags/TagsModule';
import { TeamsModule } from '../../../../xlink/modules/Teams/TeamsModule';
import { VideosModule } from '../../../../xlink/modules/Videos/VideosModule';

const OxylinkNavBar = (props: NavBarProps) => {
	const ideLinkTheme = useIdelinkTheme();

	const classes = { root: 'OxylinkNavBar-root', title: 'OxylinkNavBar-title-container' };

	const content: Array<NavBarCategoryItem> = [
		{
			items: [
				OffersModule.getOffersModuleNavbar(ideLinkTheme.offers),
				NewsModule.getNewsModuleNavbar(ideLinkTheme.news),
				EventsModule.getEventsModuleNavbar(ideLinkTheme.events),
				SurveysModule.getSurveyModuleNavbar(ideLinkTheme.surveys),
				VideosModule.getVideoModuleNavbar(ideLinkTheme.videos),
				QuizzesModule.getQuizzesModuleNavbar(ideLinkTheme.quizzes),
				ChallengesModule.getChallengesModuleNavbar(ideLinkTheme.challenges),
				CollectionsModule.getCollectionsModuleNavbar(ideLinkTheme.collections),
				AuditsModule.getAuditsModuleNavbar(ideLinkTheme.audits),
				ContactsModule.getContactsNavbar(ideLinkTheme.contacts),
			],
		},
		{
			items: [
				BackUsersModule.getBackUsersModuleNavbar(ideLinkTheme.admins),
				TeamsModule.getTeamsModuleNavbar(ideLinkTheme.teams),
				AreasModule.getAreasModuleNavbar(ideLinkTheme.areas),
				SectorsModule.getSectorsModuleNavbar(ideLinkTheme.sectors),
				ShopsModule.getShopsModuleNavbar(ideLinkTheme.shops),
				FrontUsersModule.getFrontUsersModuleNavbar(ideLinkTheme.users),
				StatsModule.getStatsModuleNavbar(ideLinkTheme.stats),
				RolesModule.getRolesModuleNavbar(ideLinkTheme.roles),
				TagsModule.getTagsModuleNavbar(ideLinkTheme.tags),
			],
		},
	];

	return <NavbarBase {...props} classes={classes} content={content} />;
};

export const overrideOxylinkNavBar = () => NavBarFactory.register('**', OxylinkNavBar);
